import React, { FC } from 'react'
import { Box, Paper, Typography } from '@mui/material'
import { DataGridPremium, GridColDef } from '@mui/x-data-grid-premium'
import { DataLoad, TableToolbar } from 'src/components/ui'
import { useSensorConfigurationAnalyticsSummaryRequest } from 'src/hooks/api'
import { formatNullableNumber } from 'src/utils/formatters'
import { ConfigurationAnalyticsGridRow, buildConfigurationAnalyticsRows } from './configurationAnalyticsRows'

const columns: GridColDef<ConfigurationAnalyticsGridRow>[] = [
  {
    field: 'metric',
    headerName: 'Metric',
    flex: 1.5,
    minWidth: 260,
    sortable: false,
    disableColumnMenu: true,
    renderCell: ({ row }) => (
      <Typography variant="body2" sx={{ whiteSpace: 'normal', pl: row.indent ? 3 : 0 }}>
        {row.metric}
      </Typography>
    )
  },
  {
    field: 'value',
    headerName: 'Amount',
    flex: 1,
    minWidth: 120,
    sortable: false,
    disableColumnMenu: true,
    valueFormatter: ({ value }: { value?: number | null }) => formatNullableNumber(value)
  }
]

export const SensorConfigurationAnalyticsSummarySection: FC = () => {
  const { data, error, isInitialLoading, isError } = useSensorConfigurationAnalyticsSummaryRequest()
  const rows = buildConfigurationAnalyticsRows(data)

  return (
    <DataLoad isLoading={isInitialLoading} isError={isError} errorMessage={error?.message}>
      <Paper>
        <Box sx={{ maxWidth: '100%' }}>
          <DataGridPremium<ConfigurationAnalyticsGridRow>
            autoHeight
            pagination={false}
            hideFooterPagination
            disableRowSelectionOnClick
            rows={rows}
            columns={columns}
            rowCount={rows.length}
            getRowId={(row) => row.key}
            getRowHeight={() => 'auto'}
            rowThreshold={2}
            columnThreshold={2}
            slots={{ toolbar: () => <TableToolbar exportedFileName={`${document.title}_configuration_summary`} /> }}
            sx={{
              border: 'none',
              '& .MuiDataGrid-cell': { py: 1 },
              '& .MuiDataGrid-columnHeaderTitleContainerContent': { paddingLeft: '5px', overflow: 'visible' },
              '& .MuiDataGrid-columnHeaderTitle': {
                whiteSpace: 'normal',
                lineHeight: 1,
                fontSize: '13px',
                fontWeight: 400,
                color: 'rgba(0, 0, 0, 0.6)',
                overflow: 'visible'
              }
            }}
          />
        </Box>
      </Paper>
    </DataLoad>
  )
}
